import { CheckoutConfig, CheckoutStepType } from '@spartacus/checkout/base/root';

export const b2bCheckoutConfig: CheckoutConfig = {
  checkout: {
    steps: [
      {
        id: 'deliveryAddress',
        name: 'checkoutProgress.deliveryAddress',
        routeName: 'checkoutDeliveryAddress',
        type: [CheckoutStepType.DELIVERY_ADDRESS],
        nextStepLabel: 'checkoutAddress.goToShipping',
        previousStepLabel: 'checkoutAddress.backToCart'
      },
      {
        id: 'deliveryMode',
        name: 'checkoutProgress.deliveryMode',
        routeName: 'checkoutDeliveryMode',
        type: [CheckoutStepType.DELIVERY_MODE, CheckoutStepType.PAYMENT_TYPE],
        nextStepLabel: 'checkoutShipping.goToReview',
        previousStepLabel: 'checkoutShipping.backToAddress'
      },
      {
        id: 'reviewOrder',
        name: 'checkoutProgress.reviewOrder',
        routeName: 'checkoutReviewOrder',
        type: [CheckoutStepType.REVIEW_ORDER]
      }
    ]
  }
};
